import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DashboardStats {
  kontrolltermine_aktuell: number;
  kontrolltermine_bearbeitung: number;
  kontrolltermine_freigabe: number;
  anzahl_kunden: number;
  anzahl_standorte: number;
}

export interface DashboardStatsResponse {
  success: boolean;
  data: DashboardStats;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardStatsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Get dashboard statistics
   */
  getStats(): Observable<DashboardStatsResponse> {
    // Protected route (requires authentication)
    return this.http.get<DashboardStatsResponse>(`${this.apiUrl}/stats`);
  }
}
